'use client'

import { Stack, styled } from '@mui/material'

export const StyledEndMatter = styled(Stack)(({ theme }) => ({
  width: '100%',
  backgroundColor: 'white',
  borderTop: `1px solid ${theme.palette.primary.main}`,
  padding: theme.spacing(4),
  position: 'relative',

  '*': {
    fontFamily: 'Sofia Sans Variable',
  },

  '.wrapper': {
    maxWidth: '1024px',
    width: '100%',
    margin: '0 auto',

    '.logo': {
      textAlign: 'center',
      margin: theme.spacing(0, 'auto', 6),
      width: 'fit-content',
    },

    '.copy': {
      fontSize: '.8rem',
    },
	  
	

    // Scoped universal link styling
    a: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 500,
      WebkitTapHighlightColor: 'transparent',

      '&:hover': {
        textDecoration: 'underline', color:theme.palette.primary.main
      },

      '&:focus, &:active, &:visited': {
        color: theme.palette.primary.main,
        textDecorationColor: theme.palette.primary.main,
        outline: 'none',
      },

      // Specifically target <span> inside links
      '& span': {
        color: theme.palette.primary.main,
        fontWeight: 500,

        '&:hover': {
          textDecoration: 'underline', color:theme.palette.primary.main
        },

        '&:focus, &:active, &:visited': {
          color: theme.palette.primary.main,
			'&:hover': {
          textDecoration: 'underline', color:theme.palette.primary.main
        },
        },
      },
    },
  },
 
	'.open-cookie-preferences': {
  color: theme.palette.primary.main,
  textDecoration: 'none',
  fontWeight: 500,
  WebkitTapHighlightColor: 'transparent',

  '&:hover': {
    color: 'theme.palette.primary.main !important',
    textDecoration: 'underline !important',
    '--Link-underlineColor': theme.palette.primary.main,
  },
},

}))
